module.exports = __webpack_public_path__ + "static/media/grid-item-b15.025c954a.png";